import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

export const AuthShell = ({ eyebrow, title, subtitle, children, footer, testid }) => (
  <main
    data-testid={testid}
    className="min-h-screen bg-[#0F172A] text-white flex flex-col"
  >
    <div className="px-5 sm:px-8 py-5">
      <Link to="/" data-testid="auth-brand-home" className="inline-flex items-center gap-2.5">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white text-[#0F172A] font-display font-bold">
          S
        </span>
        <span className="leading-none">
          <span className="block font-display font-semibold tracking-tight text-[15px]">
            SkillPreneur
          </span>
          <span className="block text-[10px] uppercase tracking-[0.24em] text-slate-400">
            Academy
          </span>
        </span>
      </Link>
    </div>

    <div className="flex-1 flex items-start sm:items-center justify-center px-5 pb-14">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-[440px]"
      >
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.24em] text-[#06B6D4] font-semibold">
          <GraduationCap className="h-3.5 w-3.5" /> {eyebrow}
        </div>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tighter">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-slate-400 leading-relaxed">{subtitle}</p>
        )}

        <div className="mt-7 rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur p-6 sm:p-7">
          {children}
        </div>

        {footer && <div className="mt-5 text-sm text-slate-400 text-center">{footer}</div>}
      </motion.div>
    </div>
  </main>
);

export const Field = ({ label, hint, children }) => (
  <label className="block mb-4">
    <span className="block text-[11px] uppercase tracking-[0.18em] text-slate-400 font-semibold mb-2">
      {label}
    </span>
    {children}
    {hint && <span className="block mt-1.5 text-[11px] text-slate-500">{hint}</span>}
  </label>
);

export const inputCls =
  "w-full rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-[#06B6D4]/40 focus:border-[#06B6D4]/40 transition-colors";

export const SubmitBtn = ({ children, loading, testid }) => (
  <button
    type="submit"
    data-testid={testid}
    disabled={loading}
    className="mt-2 w-full inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#2563EB] to-[#06B6D4] px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#2563EB]/20 hover:brightness-110 active:scale-[0.99] transition-all disabled:opacity-60"
  >
    {loading ? "Please wait…" : children}
  </button>
);
